/**
 * Record Updates service — the Airtable "Record Updates" table (`tblVoiaZEqBkeuSLP`) is a command
 * queue that Zapier automations watch. We write rows; the Zaps do the heavy creation/linking.
 *
 * createConvertLeadUpdate writes a `Convert Lead` row; the existing Zap then creates the Organization
 * and Contact (when new) + the Opportunity (Project), links them, and logs history. We do NOT create
 * the Project directly. For NEW org/contact the Zap reads name/email/organization from the Lead, so the
 * convert wizard syncs any edits back onto the Lead before writing this row (see CrmConvertLeadModal).
 */
import { apiPost } from './_api.js'

const TBL_RU = 'tblVoiaZEqBkeuSLP'

/* Airtable writes return { error } on failure (the proxy passes the body through verbatim)
   instead of throwing — surface it so a bad write shows up as a real error instead of
   silently doing nothing. */
function throwOnError(res, what) {
  if (res && res.error) {
    const msg = (res.error && (res.error.message || res.error.type)) || ('Could not save the ' + what)
    throw new Error(msg)
  }
  return res
}

// Mirror the Record Updates single-select option lists (used by the convert wizard).
export const PROJECT_TYPES = ['New Build', 'Addition', 'Remodel', 'Remodel and Addition', 'Tenant Improvement', 'Retrofit', 'Interior Design', 'Retroactive Permit']
export const BUILDING_TYPES = ['Single-Family Residence', 'Multi-Family Residence', 'Accessory Dwelling Unit', 'Hospitality - Lodging', 'Hospitality - Dining', 'Commercial - Office', 'Commercial - Retail', 'Commercial - Other', 'Mixed Use', 'Education - Schoole', 'Education - Administrative', 'Other']

/**
 * Queue a Convert Lead record update for the Zap to process.
 * @param {{ leadId, orgMode:'new'|'existing', orgId?, contactMode:'new'|'existing', contactId?,
 *           opportunityName, projectType, buildingType }} p
 */
export async function createConvertLeadUpdate(p) {
  const fields = {
    'Record Update Type': 'Convert Lead',
    'Link to Lead': [p.leadId],
    'Organization': p.orgMode === 'new' ? 'Create New' : 'Choose Existing',
    'Contact': p.contactMode === 'new' ? 'Create New' : 'Choose Existing',
    'Opportunity Name': p.opportunityName || '',
    'Project Type': p.projectType || '',
    'Building Type': p.buildingType || '',
  }
  if (p.orgMode === 'existing' && p.orgId) fields['Link to Organization'] = [p.orgId]
  if (p.contactMode === 'existing' && p.contactId) fields['Link to Contact'] = [p.contactId]
  const res = throwOnError(await apiPost(TBL_RU, fields, { typecast: true }), 'conversion')
  return res && res.id ? res : null
}
